import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Activity } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/monitoring')({
    staticData: {
        breadcrumb: {
            title: 'Monitoring',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Activity,
        },
    },
    component: Outlet,
});
